export default "__VITE_ASSET__995c76a0__"